import { AssetGallery, type AssetGalleryProps } from "./AssetGallery";
import type { CreationView } from "@/shared/lib/creationFilters";
import { cn } from "@/shared/lib/cn";
import "./CreationsGallery.css";

/** The same gallery layouts for studio results and the workspace asset browser. */
export function CreationsGallery({ view = "original", className, ...props }: AssetGalleryProps & { view?: CreationView }) {
  return <AssetGallery {...props} data-view={view} className={cn("creations-gallery", className)} />;
}
